var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_center" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c("div", { staticClass: "search-content" }, [
          _c("div", { staticClass: "mainBtn" }),
          _c(
            "div",
            { staticClass: "searchBtn" },
            [
              _c("span", { staticClass: "label-form" }, [
                _vm._v("关键字搜索："),
              ]),
              _c("el-input", {
                staticStyle: { width: "200px" },
                attrs: { clearable: "", placeholder: "项目名称/举报内容" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getDataList.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.dataForm.searchKey,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "searchKey", $$v)
                  },
                  expression: "dataForm.searchKey",
                },
              }),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "12px" },
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.getDataList },
                },
                [_vm._v("搜索")]
              ),
              _c("el-divider", { attrs: { direction: "vertical" } }),
              _c("el-button", {
                attrs: { icon: "el-icon-refresh", type: "text" },
                on: { click: _vm.refresh },
              }),
            ],
            1
          ),
        ]),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dataListLoading,
                expression: "dataListLoading",
              },
            ],
            staticClass: "table-content",
            attrs: {
              data: _vm.dataList,
              "header-cell-style": this.$globalGrayTableHeaderStyle,
              height: _vm.tableMaxHeight,
              border: "",
              stripe: "",
            },
            on: { "selection-change": _vm.selectionChangeHandle },
          },
          [
            _c("el-table-column", {
              attrs: {
                index: _vm.getRowsIndex,
                align: "center",
                fixed: "",
                "header-align": "center",
                label: "序号",
                type: "index",
                width: "60",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "项目类型",
                prop: "tradeTypeName",
                width: "100",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                align: "left",
                label: "项目名称",
                prop: "projectName",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                align: "left",
                label: "举报内容",
                prop: "contentText",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": true,
                align: "left",
                label: "举报人",
                prop: "userName",
                width: "200",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                label: "举报方式",
                prop: "reportWayName",
                width: "120",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                label: "手机号码",
                prop: "userPhone",
                width: "130",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                "header-align": "center",
                label: "提交时间",
                prop: "reportTime",
                width: "160",
              },
            }),
            _c("el-table-column", {
              attrs: {
                align: "center",
                fixed: "right",
                "header-align": "center",
                label: "操作",
                width: "100",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.viewHandle(scope.row.id)
                            },
                          },
                        },
                        [_vm._v("查看")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("el-pagination", {
          attrs: {
            "current-page": _vm.pageIndex,
            "page-size": _vm.pageSize,
            "page-sizes": [10, 20, 50, 100],
            total: _vm.totalPage,
            layout: "total, sizes, prev, pager, next, jumper",
          },
          on: {
            "current-change": _vm.currentChangeHandle,
            "size-change": _vm.sizeChangeHandle,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }